export default __webpack_public_path__ + "static/media/YouTubeHomeScreen_Final.a611e784.jpeg";